'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Disclosure = require('../../components/Disclosure/Disclosure.js');
var nthBundleShippingActivity = require('@narvar/nth-bundle-shipping-activity');
var Typography = require('../../../../../../common/components/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Overview = _ref => {
  let {
    shipment
  } = _ref;
  const {
    claimsClaimDetailsShipmentsShippingActivity,
    claimsClaimDetailsShipmentsShippingActivityHideContent,
    claimsClaimDetailsShipmentsShippingActivityShowContent
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(Disclosure["default"], {
    id: `shipping-activity-${shipment.trackingNumber ?? ''}`,
    title: claimsClaimDetailsShipmentsShippingActivity ?? '',
    hideContentText: claimsClaimDetailsShipmentsShippingActivityHideContent ?? '',
    showContentText: claimsClaimDetailsShipmentsShippingActivityShowContent ?? ''
  }, shipment.history.length ? /*#__PURE__*/React__default["default"].createElement(nthBundleShippingActivity.TrackingEventsList, {
    history: shipment.history
  }) : /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, "No shipping activity available"));
};
var ShippingActivityDisclosure = nthHookTranslations.withTranslationsProvider(Overview, {
  translationKeys: ['claimsClaimDetailsShipmentsShippingActivity', 'claimsClaimDetailsShipmentsShippingActivityHideContent', 'claimsClaimDetailsShipmentsShippingActivityShowContent']
});

exports["default"] = ShippingActivityDisclosure;
